import { createApi } from '@reduxjs/toolkit/query/react'

import { BadgeData } from '~/components/QuestPanel/type'

import { apiPrivate } from '../utils/hom-api'

export const collectionApi = createApi({
  reducerPath: 'collectionApi',
  baseQuery: apiPrivate,
  tagTypes: ['Badges'],
  endpoints: (builder) => ({
    getBadges: builder.query<BadgeData[], null>({
      query: () => ({
        url: 'v1/badge',
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetBadgesQuery } = collectionApi
